export const USER_INIT = {
  username: '',
  firstName: '',
  lastName: '',
  phone: '',
  division: '',
  subdivision: null,
  branchCode: null,
  position: '',
  photo: '',
  birthDate: null,
  male: null,
  email: '',
  roles: [],
  password: '',
  iin: '',
  isSystemUser: null
}

export const FILTER_INIT = {
  username: '',
  userFullname: '',
  roleCode: null,
  subdivision: null,
  projectCode: null,
  branchCode: null,
  isActive: 'all',
  isSystemUser: null
}

export const NEW_ROLE_INIT = {
  selectedRole: null,
  selectedProject: null,
  selectedBranches: []
}

export const statuses = [
  {
    color: 'primaryStatus',
    name: 'Был первичный звонок',
    code: 'initial_call'
  },
  {
    color: 'yellowStatus',
    name: 'Клиент думает',
    code: 'client_thinks'
  },
  {
    color: 'green',
    name: 'Назначена встреча',
    code: 'set_meeting'
  },
  {
    color: 'red',
    name: 'Клиент отказался',
    code: 'declined'
  },
  {
    color: 'black',
    name: 'Авто приято',
    code: 'accepted'
  },
];
